import React from 'react';
import {
    ViewAllFAQButton,
    ViewAllFAQContainer
} from './GoToHomepageButtonStyle';
import { IContent } from '../../../../types';

interface IButtonProps {
    context: IContent;
}

export const GotoHomepageButtonContainer = ({ context }: IButtonProps) => {
    return (
        <ViewAllFAQContainer
            beforeContent={context.goToHomepage}
            onClick={() =>
                (window.location.href = `${window.location.protocol + '//'}${
                    window.location.host
                }/${context.linkCode}/home`)
            }
        >
            <ViewAllFAQButton>{context.goToHomepage}</ViewAllFAQButton>
        </ViewAllFAQContainer>
    );
};
